// Hook listy pozycji własnej oferty - GET /sales-crm/my-offers/:id/positions

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface ISalesCrmMyOfferPositionStock {
  warehouseId: number;
  name: string;
  quantity: number;
  productUnitId: number;
}

export interface ISalesCrmMyOfferPriceThreshold {
  qtyFrom: number;
  price: number;
}

export interface ISalesCrmMyOfferPosition {
  id: number;
  productId: number | null;
  productName: string | null;
  symbol: string | null;
  category: string | null;
  tags: string[] | null;
  imageUrl: string | null;
  quantity: number | null;
  unit: string | null;
  productUnitId: number | null;
  warehouseId: number | null;
  priceNetCatalog: number | null;
  priceNetList: number | null;
  priceNetSales: number | null;
  priceGrossCatalog: number | null;
  priceGrossList: number | null;
  priceGrossSales: number | null;
  discountPct: number | null;
  discountValue: number | null;
  priceThresholds: ISalesCrmMyOfferPriceThreshold[] | null;
  priceThresholdsAsVariants: boolean;
  stocks: ISalesCrmMyOfferPositionStock[];
}

export interface ISalesCrmMyOfferPositionsResponse {
  items: ISalesCrmMyOfferPosition[];
  page: number;
  totalCount: number;
  totals: { valueNet: number; valueGross: number };
}

export const getSalesCrmMyOfferPositionsQueryKey = (
  offerId: string | number,
  params?: { page?: number; limit?: number }
) => ['sales-crm', 'my-offer', String(offerId), 'positions', params] as const;

const getSalesCrmMyOfferPositions = (
  offerId: string | number,
  params?: { page?: number; limit?: number }
): Promise<ISalesCrmMyOfferPositionsResponse> => {
  const queryParams: Record<string, number> = {};
  if (params?.page) queryParams.page = params.page;
  if (params?.limit) queryParams.limit = params.limit;
  return axios.get(`/sales-crm/my-offers/${offerId}/positions`, { params: queryParams });
};

export const useGetSalesCrmMyOfferPositions = (
  offerId: string | number,
  params?: { page?: number; limit?: number },
  options?: UseQueryOptions<ISalesCrmMyOfferPositionsResponse, IError>
) =>
  useQuery<ISalesCrmMyOfferPositionsResponse, IError>(
    getSalesCrmMyOfferPositionsQueryKey(offerId, params),
    () => getSalesCrmMyOfferPositions(offerId, params),
    {
      ...options,
      enabled: options?.enabled !== false && String(offerId).trim().length > 0
    }
  );
